import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TicketDetailsOverviewHQBaseComponent } from '@resident-nx/shared';
import { LabelWebComponent } from '../../../../atoms/label/label.component';
import { DefaultValuePipe, IconWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { TicketImageViewerComponent } from '../../../../atoms/ticket-image-viewer/ticket-image-viewer.component';
import { DatePipe } from '@angular/common';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-details-overview-hq',
  templateUrl: './ticket-details-overview-hq.component.html',
  styleUrls: ['./ticket-details-overview-hq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    IconWebComponent,
    LabelWebComponent,
    ImmomioButtonComponent,
    TicketImageViewerComponent,
    DefaultValuePipe,
    DatePipe,
  ],
})
export class TicketDetailsOverviewHQWebComponent extends TicketDetailsOverviewHQBaseComponent {}
